import React, { createContext, useContext, useState, ReactNode } from 'react';
import { LoginStep } from '../components/login/LoginModal';

interface LoginModalContextType {
  currentStep: LoginStep;
  email: string;
  setCurrentStep: (step: LoginStep) => void;
  setEmail: (email: string) => void;
  resetLoginModal: () => void;
}

const LoginModalContext = createContext<LoginModalContextType | undefined>(undefined);

export const useLoginModalContext = () => {
  const context = useContext(LoginModalContext);
  if (context === undefined) {
    throw new Error('useLoginModalContext must be used within a LoginModalProvider');
  }
  return context;
};

interface LoginModalProviderProps {
  children: ReactNode;
  initialStep?: LoginStep;
}

export const LoginModalProvider: React.FC<LoginModalProviderProps> = ({ 
  children, 
  initialStep = 'email' 
}) => {
  const [currentStep, setCurrentStep] = useState<LoginStep>(initialStep);
  const [email, setEmail] = useState('');

  const resetLoginModal = () => {
    setCurrentStep('email');
    setEmail('');
  };

  const value: LoginModalContextType = {
    currentStep,
    email,
    setCurrentStep,
    setEmail,
    resetLoginModal,
  };

  return (
    <LoginModalContext.Provider value={value}>
      {children}
    </LoginModalContext.Provider>
  );
};
